<!-- <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
  <div class="comments">
    <mat-card *ngFor="let comment of comments" [ngClass]="{informerComment: !comment.createdBy, classifierComment: comment.createdBy}">
      <mat-card-subtitle >
        {{comment.createdBy ?? ("COMPLAINTS.INFORMER"|translate)}} - {{comment.createdDate | date:'short'}}
      </mat-card-subtitle>
      {{comment.comment}}
    </mat-card>
  </div>
  <div class="send-comment-area">
    <mat-form-field>
      <mat-label>Ingrese un comentario</mat-label>
      <textarea matInput #commentText [disabled]="loading"></textarea>
    </mat-form-field>
    <div>
      <button mat-raised-button (click)="addComment(commentText.value); commentText.value = ''" [disabled]="loading">{{'BUTTONS.SEND' | translate}}</button>
    </div>
  </div> -->

<!-- CHAT -->

    
<div class="chat" fxFlex fxLayout="row wrap" fxFlex="100%">
      
  <div *ngIf="isDialog" fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="0 1 auto" class="diag-header">
    <h1 class="font-weight-600">{{ 'DIALOGS.TITLES.COMMENTS' | translate }}</h1>
    <button mat-raised-button color="primary" (click)="onDismiss()">
        <!-- <mat-icon>close</mat-icon> -->
        {{'DIALOGS.ACTIONS.CLOSE' | translate}}
    </button>
  </div>
    <!-- CHAT CONTENT -->
    <div id="chat-content" fxLayout="row" fxFlex="100%" xLayoutAlign="start" >

      <!-- CHAT MESSAGES -->
      <div class="chat-messages">

          <!-- MESSAGE -->
          <div *ngFor="let message of comments; let i = index" class="message-row"
                [ngClass]="{
                          'me': message.createdBy !== null,
                          'contact': message.createdBy === null,
                          'first-of-group': true,
                          'last-of-group': true
                          }">

            <div fxLayoutAlign="space-between center">

              <div class="bubble" [ngClass]="{'primary': message.createdBy === userName}" 
                  *ngIf="message.followUpActionId == 2 || message.followUpActionId == 3">
                  <div class="message" >{{message.comment}}</div>   
                  <br>                      
                  <div *ngIf="!isDialog" class="time">
                    <span class="mr-8" style="color: black!important">{{message.createdBy == 'Integrations' ?
                       ('BUTTONS.CHAT-ALERTER' | translate) : message.createdBy}}</span>
                    <span style="color: black!important">{{message.createdDate | date:'short'}}</span>
                  </div>
              </div>

              <div class="bubble" [ngClass]="{'primary': message.createdBy === null}" 
                *ngIf="message.followUpActionId == 6">
                  <div class="message">{{"COMPLAINT.CHAT_USER_HAS_ENTER_TO_COMPLAINT" | translate}}</div>
                  <br>                
                  <div *ngIf="!isDialog" class="time">
                    <span class="mr-8" >{{('BUTTONS.CHAT-ALERTER' | translate)}}</span>
                    <span>{{message.createdDate | date:'short'}}</span>
                  </div>
              </div>
              
              <div class="bubble" [ngClass]="{'primary': message.createdBy === userName}" 
                  *ngIf="!message.followUpActionId && message.comment !== null">
                  <div class="message" >{{message.comment}}</div> 
                  <br>                        
                  <div *ngIf="!isDialog" class="time">
                    <span class="mr-8" style="color: black!important">{{message.createdBy == 'Integrations' ?
                      ('BUTTONS.CHAT-ALERTER' | translate) : message.createdBy}}</span>
                    <span style="color: black!important">{{message.createdDate | date:'short'}}</span>
                  </div>
              </div>

              <button *ngIf="message.id == 0" mat-icon-button 
                class="delete-msg"
                matTooltip="{{'BUTTONS.DELETE' | translate}}"
                (click)="deleteMessage(i)">
                  <mat-icon>delete</mat-icon>
              </button>

            </div>

          </div>
          <!-- / MESSAGE -->

      </div>
      <!-- CHAT MESSAGES -->

    </div>
  <!-- / CHAT CONTENT -->

  <!-- CHAT FOOTER -->
  <div class="chat-footer mat-elevation-z6" fxLayout="row"  fxFlex="100%" >

      <!-- REPLY FORM -->
      <div class="reply-form" fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="center center">

          <form #replyForm="ngForm" fxFlex fxLayout="row" fxLayoutAlign="start center"
            [ngStyle]="{'filter' : editable ? 'opacity(1)':'opacity(0.5);'}">

              <mat-form-field appearance="outline" class="" fxFlex fxLayout="row" fxLayoutAlign="start center" floatLabel="never"> <!--appearance="standard"-->
                  <textarea matInput #commentText [disabled]="loading || !editable" placeholder="{{'BUTTONS.CHAT-INPUT' | translate}}"
                            ngModel name="commentText" [rows]="1" [cdkTextareaAutosize]="true" class="m-12"
                            (keydown.enter)="addComment(commentText.value); commentText.value = ''; $event.preventDefault();"></textarea>
              </mat-form-field>

              <button class="send-message-button"
                      fxFlex fxLayout="row" fxLayoutAlign="end center"
                      mat-icon-button
                      color="primary"
                      type="submit"
                      aria-label="Send message"
                      (click)="addComment(commentText.value); commentText.value = ''"
                      [disabled]="loading || !editable">
                <mat-icon class="" [ngClass]="{'secondary-text' : !editable}">send</mat-icon>
              </button>

          </form>

      </div>
      <!-- / REPLY FORM -->
  </div>
  <!-- / CHAT FOOTER-->
</div>
<!-- / CHAT -->